import React, { useState } from 'react';
import { useConnect } from '@lore/query-connect';
import { useUser } from '@lore/auth';
import { PayloadStates } from '@lore/utils';
import { Link } from 'react-router-dom';
import Loader from '../../components/Loader';
import SectionTitle from './SectionTitle';
import EmptyState from '../../components/EmptyState';
import Message from '../project-messages-user/Message';
import { DateTime } from 'luxon';
import { EnvelopeIcon } from '@heroicons/react/24/outline';

export default function RecentMessages(props) {
  const currentUser = useUser();
  const [timestamp] = useState(
    DateTime
      .now()
      .setZone(currentUser.data.timezone)
      .minus({ days: 14 } )
      .toISO()
  );

  DateTime.now().setZone('America/New_York').minus({weeks:1}).endOf('day').toISO();

  const title = 'Recent messages';
  const subtitle = `Check out the messages you've received in the last 14 days.`;
  const link = (
    <Link to="/messages" className="text-cs-blue-500 text-base">
      View all messages
    </Link>
  );

  const messages = useConnect('message.find', {
    where: {
      eager: {
        $where: {
          senderId: {
            $not: currentUser.id
          },
          createdAt: {
            $gte: timestamp
          }
        }
      }
    },
    pagination: {
      pageSize: 5,
      order: 'createdAt desc'
    }
  });

  if (messages.state === PayloadStates.FETCHING) {
    return (
      <div>
        <SectionTitle
          title={title}
          subtitle={subtitle}
          link={link}
        />
        <div>
          <Loader className="mx-7" />
        </div>
      </div>
    );
  }

  if (messages.data.length === 0) {
    return (
      <div>
        <SectionTitle
          title={title}
          subtitle={subtitle}
          link={link}
        />
        <EmptyState
          icon={EnvelopeIcon}
          title="Looks like you don't have any messages...yet!"
        />
      </div>
    );
  }

  return (
    <div>
      <SectionTitle
        title={title}
        subtitle={subtitle}
        link={link}
      />
      <div className="grid grid-cols-1 gap-4">
        {messages.data.map(function(message, index) {
          return (
            <div
              key={message.id || message.cid}
              className="bg-white shadow-cs-flat -m-0.5 border-2 border-cs-gray-100 rounded-cs-10 p-4 overflow-hidden relative"
            >
              <Link to={`/messages/${message.data.senderId}`} className="absolute h-full w-full -m-4" />
              <Message message={message} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
